import { type FetchUserMeData, useMeQueries, UseUserQueryKeys } from '@capsicum/common';
import { useQueryClient } from '@tanstack/react-query';
import { useCallback } from 'react';

type UseMeOptions = { enabled: boolean };

export const useMe = (options?: UseMeOptions) => {
	const {
		data: me,
		error: meError,
		isFetching: isMeFetching,
		isLoading: isMeLoading,
		refetch: refetchMe
	} = useMeQueries(options);

	const queryClient = useQueryClient();

	const updateUserMeData: (username: FetchUserMeData) => void = (newData: FetchUserMeData) => {
		queryClient.setQueryData<FetchUserMeData>(UseUserQueryKeys, () => {
			return {
				...newData
			};
		});
	};

	return {
		isMeFetching,
		isMeLoading: isMeLoading,
		// Spreading to avoid TS possible undefined. Should be updated in the future as it can be undefined within the guards.
		me: { ...me },
		meError: meError,
		refetchMe: useCallback(async () => {
			await refetchMe();
		}, [refetchMe]),
		updateUserMeData
	} as const;
};
